import { getLogger } from 'loglevel';

const log = getLogger('CancellationAPI');

export const baseUrl = '';

const handleErrors = (response) => {
  if (!response.ok) {
    log.error('Server response different than 200: %o', {
      url: response.url,
      status: response.status,
      statusText: response.statusText,
    });

    return response.json().then((json) => {
      const error = new Error(response.statusText);
      error.details = json;
      throw error;
    });
  }
  return response.json();
};

export const getReservations = ({ firstName, lastName, reservationId, email }) => {
  const params = new URLSearchParams({
    fn: firstName,
    ln: lastName,
    rId: reservationId,
    email,
  }).toString();
  return fetch(`${baseUrl}/adventures/rs/day/reservations?${params}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(handleErrors)
    .catch((e) => {
      log.error('Error in capture call: %o', {
        name: e.name,
        message: e.message,
        stack: e.stack,
      });
      return Promise.reject(new Error('default'));
    });
};

export const submitCancellation = (payload) =>
  fetch(`${baseUrl}/adventures/rs/day/reservations/cancel`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
    .then(handleErrors)
    .catch((e) => {
      log.error('Error in capture call: %o', {
        name: e.name,
        message: e.message,
        stack: e.stack,
      });

      return Promise.reject(e);
    });
